import { listDateFormats, listDateTimeFormats, listTimeFormats } from 'core/api';
import { AntSelect } from './ant/ant-select/antSelect';
import { AntSelectPropsGeneric } from './ant/ant-select/types';
import { ApiRequest } from 'framework/api';
import { useRemoteListForSelect } from 'framework/api';
import { observer } from 'mobx-react';
import React from 'react';
import { dateToString } from 'tools/dateTimeUtils';
import { fromLegacyFormat } from 'tools/dateTime/fromLegacyFormat';

export type DateTimeFormatSelectorProps = AntSelectPropsGeneric<string>;

const converter = (type: 'time' | 'date' | 'datetime') => {
	const date = new Date().getTime();
	return (x: string) => ({ label: dateToString(date, type, fromLegacyFormat(x)), value: x });
};

const useFormatOptions = (
	request: ApiRequest<string[]>,
	type: 'time' | 'date' | 'datetime',
	props: DateTimeFormatSelectorProps,
) => {
	const { options, ...rest } = useRemoteListForSelect(request, { converter: converter(type) });

	// like a plain dropdown: with no value, the first item is selected
	React.useEffect(() => {
		if (!props.value && options.length) {
			props.onChange?.(options[0].value, options[0]);
		}
	}, [options, props.value]);

	return { ...rest, options };
};

export const DateTimeFormatSelector = observer((props: DateTimeFormatSelectorProps) => {
	const remoteData = useFormatOptions(listDateTimeFormats(), 'datetime', props);

	return <AntSelect {...remoteData} {...props} />;
});

export const DateFormatSelector = observer((props: DateTimeFormatSelectorProps) => {
	const remoteData = useFormatOptions(listDateFormats(), 'date', props);

	return <AntSelect {...remoteData} {...props} />;
});

export const TimeFormatSelector = observer((props: DateTimeFormatSelectorProps) => {
	const remoteData = useFormatOptions(listTimeFormats(), 'time', props);

	return <AntSelect {...remoteData} {...props} />;
});
